import ChatWebView from './ChatWebView';

export default ChatWebView;
